import { UseFormReturn } from "react-hook-form";
import { codeToFlag } from "@/features/regions/utils/code-to-flag";
import { BundleWizardData } from "./wizard-form";

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex justify-between gap-4 py-2 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm text-gray-900 text-right">{value || "—"}</span>
    </div>
  );
}

export default function StepReview({
  form,
  productName,
}: {
  form: UseFormReturn<BundleWizardData>;
  productName?: string;
}) {
  const v = form.getValues();
  const totalSessions = (v.session_types ?? []).length;

  const expiry = v.is_expiration_in_days
    ? v.expires_in_day
      ? `${v.expires_in_day} day(s)`
      : "—"
    : v.expires_in_month
      ? `${v.expires_in_month} month(s)`
      : "No expiry";

  return (
    <div className="rounded-lg border border-gray-200 divide-y divide-gray-100">
      <div className="px-4 py-3 bg-gray-50">
        <p className="text-base font-semibold text-gray-900">{v.name}</p>
        <p className="text-xs text-gray-500">
          {productName ?? "No product"} · {codeToFlag(v.region)} {v.region}{" "}
          · {v.status}
        </p>
      </div>
      <div className="px-4 py-2">
        <Row
          label="Price"
          value={`${v.currency} ${(v.amount || 0).toLocaleString()}`}
        />
        <Row label="Reschedule amount" value={v.reschedule_amount} />
        <Row label="Type" value={v.type} />
        <Row label="Sessions" value={totalSessions} />
        <Row label="Total allowed users" value={v.total_allowed_user} />
        <Row label="Expiry" value={expiry} />
        <Row label="User payment type" value={v.user_payment_type} />
        <Row label="Payment URL" value={v.payment_page_link} />
        <Row label="Forms" value={v.form_ids?.length || 0} />
        <Row label="Coupons" value={v.coupon_ids?.length || 0} />
      </div>
    </div>
  );
}
